export default __webpack_public_path__ + "static/media/701.c1049634.png";